/* ============================================================================
   Pin-first (Horizon) — v2026-08-15
   Fixa o produto do ad na 1ª posição da grelha da coleção, na cor do ad.
   Parâmetros no URL da coleção:
     ?first=<handle | URL completo /products/...>   (obrigatório)
     &variant=<id numérico>                          (opcional — cor/tamanho)
   Estratégia (≠ do original WeScale/Den p/ Dawn): NÃO reconstrói a grelha nem
   pede cartões a views alternativas (era aí que vivia o bug de cache do Aaron
   James). Move o cartão já renderizado para a frente; se estiver noutra página
   da paginação, vai buscá-lo ao HTML dessa página. Depois troca imagem+links
   para a variante. Se nada bater certo, não faz nada (grelha normal).
   Limite conhecido: o produto tem de pertencer à coleção de aterragem
   (sem `source=` cross-coleção); filtrar/ordenar refaz a grelha e desfaz o pin.
============================================================================ */
(() => {
  const qp = new URLSearchParams(location.search);
  let raw = (qp.get('first') || '').trim();
  if (!raw) return;

  let handle = '';
  let variantFromUrl = '';
  if (raw.startsWith('http')) {
    try {
      const u = new URL(raw);
      const segs = u.pathname.split('/').filter(Boolean);
      if (segs[0] === 'products' && segs[1]) handle = segs[1];
      variantFromUrl = u.searchParams.get('variant') || '';
    } catch (_) {}
  } else {
    handle = raw.split('/').filter(Boolean).pop() || '';
  }
  if (!handle) return;

  const vParam = qp.get('variant') || variantFromUrl;
  const variantId = /^\d+$/.test(vParam) ? vParam : '';

  const ready = (fn) =>
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', fn, { once: true })
      : fn();

  const cardHandle = (li) => {
    const a = li.querySelector('a[href*="/products/"]');
    if (!a) return '';
    try {
      const path = new URL(a.getAttribute('href'), location.origin).pathname;
      const segs = path.split('/').filter(Boolean);
      const i = segs.indexOf('products');
      return i >= 0 ? (segs[i + 1] || '') : '';
    } catch (_) {
      return '';
    }
  };

  const findCard = (root) => {
    for (const li of root.querySelectorAll('li.product-grid__item')) {
      if (cardHandle(li) === handle) return li;
    }
    return null;
  };

  ready(async () => {
    const grid = document.querySelector('ul.product-grid');
    if (!grid) return;

    let card = findCard(grid);

    if (!card) {
      /* paginação: procurar nas páginas seguintes (máx. 4 fetches) */
      const lastPage = parseInt(grid.getAttribute('data-last-page') || '1', 10);
      for (let p = 2; p <= Math.min(lastPage, 5) && !card; p++) {
        try {
          const u = new URL(location.href); /* mantém preview_theme_id no draft */
          u.searchParams.set('page', String(p));
          const r = await fetch(u.toString(), { credentials: 'same-origin' });
          if (!r.ok) continue;
          const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
          const remoteGrid = doc.querySelector('ul.product-grid');
          const hit = remoteGrid && findCard(remoteGrid);
          if (hit) card = document.importNode(hit, true);
        } catch (_) {}
      }
    }
    if (!card) return;

    grid.prepend(card);

    if (!variantId) return;
    try {
      const prod = await fetch(`/products/${encodeURIComponent(handle)}.js`).then((r) => r.json());
      const varObj = (prod.variants || []).find((x) => String(x.id) === variantId);
      const imgSrc = varObj && varObj.featured_image && varObj.featured_image.src;
      if (imgSrc) {
        card.querySelectorAll('img').forEach((el) => {
          el.src = imgSrc;
          el.removeAttribute('srcset');
          const pic = el.closest('picture');
          if (pic) pic.querySelectorAll('source').forEach((s) => s.remove());
        });
      }
      card.querySelectorAll('a[href*="/products/"]').forEach((a) => {
        try {
          const u = new URL(a.getAttribute('href'), location.origin);
          u.searchParams.set('variant', variantId);
          a.setAttribute('href', u.pathname + u.search);
        } catch (_) {}
      });
    } catch (_) {}
  });
})();
